import React, { useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import FAQSection from './components/FAQSection';

// Define styled components
const Root = styled(Box)({
  backgroundColor: '#e9edf1',
  minHeight: 'calc(100vh - 64px)',
  padding: '32px 35px',
});

const PageTitle = styled(Typography)({
  fontSize: '32px',
  fontWeight: 700,
  fontFamily: 'Poppins',
  color: '#012237',
  marginBottom: '16px',
});

const PageSubtitle = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Poppins',
  color: 'rgba(0, 0, 0, 0.7)',
  marginBottom: '24px',
  maxWidth: '100%',
});

const ContentContainer = styled(Box)({
  maxWidth: '100%',
  marginLeft: '0',
  marginRight: '0',
  textAlign: 'left',
});

interface AgenticCommerceOverviewProps {
  setTitle?: (title: string) => void;
  isRetailer?: boolean;
}

const AgenticCommerceOverview: React.FC<AgenticCommerceOverviewProps> = (props) => {
  useEffect(() => {
    // Set the page title
    if (props.setTitle) {
      props.setTitle('Agentic Commerce');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.setTitle]);

  return (
    <Root>
      <ContentContainer>
        {/* Page Title and Description */}
        <PageTitle>
          Welcome to Agentic Commerce
        </PageTitle>
        <PageSubtitle>
          Enable AI-driven capabilities and sell more through trusted integrations, starting with PayPal.
        </PageSubtitle>

        {/* Hero Section with CTA */}
        <HeroSection />

        {/* How It Works Section */}
        <HowItWorks />

        {/* FAQ Section */}
        <FAQSection />
      </ContentContainer>
    </Root>
  );
};

export default AgenticCommerceOverview;
